import React from 'react'
import { useTranslation, Link, useI18next } from 'gatsby-plugin-react-i18next'
import { Globe } from 'lucide-react'
import cn from 'classnames'

import xcadLogo from '~img/new-xcad-logo.svg'
import * as s from './Footer.module.scss'

const Footer = () => {
  const { t } = useTranslation()
  const { languages, originalPath, language } = useI18next()

  const links = [
    {
      id: 1,
      columnTitle: t('download'),
      paths: [
        {
          id: 1,
          title: t('chrome'),
          url: 'https://chromewebstore.google.com/detail/xcad-network/elcdacbfpnjajikgpenambffmmoimeea',
        },
        {
          id: 2,
          title: t('android'),
          url: 'https://play.google.com/store/apps/details?id=com.xcadnetwork.app&hl=en-US',
        },
        { id: 3, title: t('ios'), url: '/ios' },
      ],
    },
    {
      id: 2,
      columnTitle: t('explore'),
      paths: [
        { id: 1, title: t('project'), url: '/project' },
        { id: 2, title: t('creators'), url: '/creators' },
        { id: 3, title: t('fans'), url: '/fans' },
      ],
    },
    {
      id: 3,
      columnTitle: t('token'),
      paths: [{ id: 1, title: t('buyXcad'), url: '/xcad-buy' }],
    },
    {
      id: 4,
      columnTitle: t('community'),
      paths: [
        { id: 1, title: 'Twitter', url: 'https://twitter.com/XcademyOfficial' },
        { id: 2, title: 'Telegram', url: 'https://t.me/xcademy' },
        { id: 3, title: 'Medium', url: 'https://medium.com/xcademy' },
      ],
    },
  ]

  return (
    <footer className={s.footer}>
      <div className={s.footerContainer}>
        <div className={s.logoWrapper}>
          <img src={xcadLogo} alt="Xcademy" width={104} height={45} />
        </div>

        <div className={s.paths}>
          {links?.map((col, index) => (
            <div
              key={col.id}
              className={`${s.column} ${
                index === links.length - 1 ? s.lastItem : ''
              }`}
            >
              <p className={s.columnTitle}>{col.columnTitle}</p>
              {col?.paths.map((path) => (
                <a key={path.id} href={path.url} className={s.link}>
                  {path.title}
                </a>
              ))}
              {col.id === 3 && (
                <div className={s.language}>
                  <div>
                    <Globe size={20} />
                  </div>
                  <div className={s.languages}>
                    {languages.map((lng) => (
                      <Link
                        key={lng}
                        to={originalPath}
                        language={lng}
                        className={cn({ [s.activeLang]: lng === language })}
                      >
                        {lng.toUpperCase()}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div>
          <hr className={s.hline} />
          <p className={s.trademark}>
            All Rights Reserved &copy; XCAD Network {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
